import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import { ColumnButton } from "@utils/extra-style";
import { renderPriceWithCurrencyWithoutUnit, addSpace } from "@utils/utils";
import AddEditSupplier from "../../../AddEditSupplier/AddEditSupplier";
import SupplierPlanningList from "../SupplierPlanningList";
import {
  GenrealInfo,
  FlexRow,
  Title,
  GridRow,
  ButtonWrapper,
  CalculationOuter,
  GridSubItem,
} from "./SupplierPlanning.styled";

const SupplierPlanning = (props) => {
  const {
    t,
    clientOrderId,
    planningLines,
    exchangeRates,
    quoteCurrency,
    isLoading,
    setRefreshState,
    planningFigures,
    jobsiteCountryId,
  } = props;
  const [openSupplierPlanningPopUp, setOpenSupplierPlanningPopUp] =
    useState(false);

  const supplierPlanningAction = () => {
    setOpenSupplierPlanningPopUp(true);
  };

  const closePlanningPopUp = () => {
    setOpenSupplierPlanningPopUp(false);
  };

  return (
    <>
      <GenrealInfo>
        <FlexRow column="1fr">
          <Title bottom="1.5rem">{t("CLIENT_ORDER_PLANNING_LINES")}</Title>
        </FlexRow>
        <GridRow column="1fr 1fr">
          <CalculationOuter>
            <GridRow column="1fr 1fr 1fr" gap="0rem" padding="4px 0px">
              {planningFigures?.totalTurnover && (
                <>
                  <GridRow borderRight="2px solid #008395" padding="6px 10px">
                    <GridSubItem color="#474747" fontSize="14px">
                      {t("SUPPLIERS_PLANNING_FIGURES_TURNOVER")}
                    </GridSubItem>
                    <GridSubItem fontWeight="700">
                      {renderPriceWithCurrencyWithoutUnit(
                        planningLines?.length !== 0
                          ? addSpace(planningFigures?.totalTurnover)
                          : "--.--",
                        quoteCurrency?.symbol,
                        quoteCurrency?.position
                      )}
                    </GridSubItem>
                  </GridRow>
                  <GridRow borderRight="2px solid #008395" padding="6px 10px">
                    <GridSubItem color="#474747" fontSize="14px">
                      {t("SUPPLIERS_PLANNING_FIGURES_MARGIN_RATE")}
                    </GridSubItem>
                    <GridSubItem fontWeight="700">
                      {(planningLines?.length !== 0
                        ? planningFigures?.totalMarginRate
                        : "--.--") + "%"}
                    </GridSubItem>
                  </GridRow>
                  <GridRow padding="6px 10px">
                    <GridSubItem color="#474747" fontSize="14px">
                      {t("SUPPLIERS_PLANNING_FIGURES_MARGIN")}
                    </GridSubItem>
                    <GridSubItem fontWeight="700">
                      {renderPriceWithCurrencyWithoutUnit(
                        planningLines?.length !== 0
                          ? addSpace(planningFigures?.totalMarginValue)
                          : "--.--",
                        quoteCurrency?.symbol,
                        quoteCurrency?.position
                      )}
                    </GridSubItem>
                  </GridRow>
                </>
              )}
            </GridRow>
          </CalculationOuter>
          <ButtonWrapper>
            <ColumnButton
              border="#1bace4"
              background="#1bace4"
              padding="10px"
              onClick={() => supplierPlanningAction()}
            >
              {t("ACTION_NEW_PLANNING_LINE")}
            </ColumnButton>
          </ButtonWrapper>
        </GridRow>
        <SupplierPlanningList
          clientOrderId={clientOrderId}
          planningLines={planningLines}
          exchangeRates={exchangeRates}
          quoteCurrency={quoteCurrency}
          isLoading
          setRefreshState={setRefreshState}
          jobsiteCountryId={jobsiteCountryId}
        />
      </GenrealInfo>
      {openSupplierPlanningPopUp && (
        <AddEditSupplier
          onClose={closePlanningPopUp}
          clientOrderId={clientOrderId}
          setRefreshState={setRefreshState}
          countryId={jobsiteCountryId}
        />
      )}
    </>
  );
};
SupplierPlanning.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SupplierPlanning);
